import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../core';

/**
 * PageNotFoundComponent
 */
@Component({
	styleUrls: ['./page-not-found.component.scss'],
	templateUrl: './page-not-found.component.html'
})

/**
 * PageNotFoundComponent
 */
export class PageNotFoundComponent implements OnInit {
	constructor(private sessionService: SessionService) {}

	public isAdmin: boolean = false;

	ngOnInit(): void {
		this.isAdmin = this.sessionService.getUser().isAdmin;
	}
}
